export default "__VITE_ASSET__Nu$TdnGh__"